import './ImageCard.css';
import { Image } from 'pure-react-carousel';

interface ImageCardProps {
  url: string;
}
export default function ImageCard({url}: ImageCardProps) {
  return (
    <div className="image-card--wrapper">
      <div className="image-container">
        <Image hasMasterSpinner src={url} alt="some description" />
      </div>
      {/* <div className="image-card--description">
        <p>Property Image Description</p>
      </div> */}
    </div>
  )
}
